module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921052651_T.b9d0f6f3.jpg";